<template>
  <label class="language-selector">
    <select :value="current" @change="onChange" class="form-select form-select-sm">
      <option value="en">English</option>
      <option value="es">Español</option>
      <option value="zh-hans">中文（简体）</option>
    </select>
  </label>
</template>

<script>
import { i18n, setLocale } from '@/i18n'

export default {
  name: 'LanguageSelector',
  computed: {
    current() {
      return i18n.global.locale.value
    }
  },
  methods: {
    onChange(e) {
      setLocale(e.target.value)
    }
  }
}
</script>

<style scoped>
.language-selector {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.label {
  font-size: 0.9rem;
}
</style>
